/**
 * Browser side of text messages. The rules themselves live in
 * supabase/functions/_shared/sms.ts so the edge functions and the settings
 * page validate numbers and sender names the same way.
 */
export {
  accountSidProblem,
  authTokenProblem,
  maskPhone,
  normaliseUkMobile,
  parseSmsSender,
  phoneProblem,
  senderLabel,
  type SmsMessageType,
  type SmsSenderKind,
} from '../../supabase/functions/_shared/sms';

export const SMS_TYPE_LABEL: Record<string, string> = {
  booking_confirmation: 'Booking confirmation',
  appointment_reminder: 'Appointment reminder',
  quote_link: 'Quote link',
  test: 'Test text',
};

export type SmsStatusTone = 'green' | 'amber' | 'rose' | 'grey';

/** Owner-facing status for a logged text. */
export function smsStatusLabel(status: string | null | undefined): { label: string; tone: SmsStatusTone } {
  switch (status) {
    case 'delivered':
    case 'read':
      return { label: 'Delivered', tone: 'green' };
    case 'sent':
      return { label: 'Sent', tone: 'green' };
    case 'failed':
      return { label: 'Failed', tone: 'rose' };
    case 'undelivered':
      return { label: 'Not delivered', tone: 'rose' };
    case 'canceled':
      return { label: 'Cancelled', tone: 'grey' };
    default:
      return { label: 'Sending', tone: 'amber' };
  }
}

export function isSmsFailure(status: string | null | undefined): boolean {
  return status === 'failed' || status === 'undelivered';
}
